import { useState } from 'react';
import { Bell } from 'lucide-react';
import { useNotifications } from '../../hooks/useNotifications';
import { NotificationPanel } from './NotificationPanel';

/**
 * Sidebar / header bell. The list itself lives in NotificationPanel so the
 * mobile bottom-bar bell opens exactly the same thing.
 */
export const NotificationBell = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { unreadCount } = useNotifications();

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen((prev) => !prev)}
                className="relative p-2 rounded-[var(--fds-radius)] text-fg-2 hover:text-fg hover:bg-raised transition-all"
                aria-label="Notifications"
            >
                <Bell className="w-5 h-5" />

                {unreadCount > 0 && (
                    <span className="absolute -top-0.5 -right-0.5 w-5 h-5 flex items-center justify-center bg-danger-fill text-on-fill text-[10px] font-bold rounded-full animate-in zoom-in duration-200">
                        {unreadCount > 9 ? '9+' : unreadCount}
                    </span>
                )}
            </button>

            <NotificationPanel isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </div>
    );
};
